import { useApi } from "shared/services/api/useApi";

export const useClientFamilies = () => {
    const { getDataAsync } = useApi();

    const getClientFamiliesFilter = async (params) => {
        const payload = await getDataAsync("clientFamiliesFilter", { params: params });
        return payload.json();
    };

    return { getClientFamiliesFilter };
};
